export function isEmpty(obj: any): boolean {
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            return false;
        }
    }
    return true;
}

export function strMapToJson(map: Map<string, string>): string {
    return JSON.stringify(map);
}

export function jsonToStrMap(data: string): Map<string, string> {
    return new Map(JSON.parse(data));
}